exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n  .mat-dialog-title {\n    text-align: center;\n}\nmat-dialog-actions {\n float: right;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/BEX-KYC-Admin/src/app/components/pages/users/logs/activity-details/activity-details.component.css
// module id = ../../../../../src/app/components/pages/users/logs/activity-details/activity-details.component.css
// module chunks = main